import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  labelStyle,
  responsiveFun,
  stroke,
  lineXaxis,
  getColours,
} from '../options';
import dict from '../../dictionary';
import ReducedData from '../../reducedData.json';
import trans from '../../translations.json';
import { DownloadButton } from '../options';
import StackedTable from './percentPositiveTotal-Table';
import { ButtonGroup } from '../buttonGroup/buttonGroup';
import './tests.scss';
import { renderToString } from 'react-dom/server';
import {
  ToolTipPercent,
} from '../toolTipClone/toolTipClone';
import { dateFormater, round } from '../utils';

const viewModes = {
  graph: 'graph',
  table: 'table',
};

const colors = getColours(['percent']);

var dates;

class PercentPositiveTotal extends Component {
  state = {
    ready: false,
    dates: [],
    series: [],
    options: {},
    selectedViewMode: viewModes.graph,
    chartRef: React.createRef(null),
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };
  componentDidMount() {
    this.setData();
  }
  prepData = () => {
    var covidData = ReducedData.covidData;
    dates = [...covidData].filter(
      (item) => item[dict.percentPositive],
    );

    let totalTested = [],
      totalTestedCount = 0,
      totalConfirmedCount = 0,
      totalConfirmed = [],
      percentConfirmed = [];

    dates.forEach((item) => {
      let total = item[dict.totalTestsCompletedinthelastday];
      let percentPositive = item[dict.percentPositive];
      let numberPositive = round((total * percentPositive) / 100, 0);

      totalTestedCount += total;

      totalTested.push([item[dict.reportedDate], totalTestedCount]);

      totalConfirmedCount += numberPositive;

      totalConfirmed.push([
        item[dict.reportedDate],
        totalConfirmedCount,
      ]);

      let totalPercentPositive = round(
        (totalConfirmedCount / totalTestedCount) * 100,
        1,
      );

      percentConfirmed.push([
        item[dict.reportedDate],
        totalPercentPositive,
      ]);
    });
    return { totalTested, totalConfirmed, percentConfirmed };
  };

  setData = () => {
    let lang = this.props.lang;
    const { percentConfirmed } = this.prepData();
    this.setState({
      series: [
        {
          name: trans.testing.titleC[this.props.lang],
          data: percentConfirmed,
        },
      ],
      options: {
        colors: colors,

        markers: {
          size: 0,
          colors: colors,
          strokeColors: '#fff',
          strokeWidth: 1,
          hover: {
            size: 9,
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          followCursor: true,
          style: { ...labelStyle },
          custom: function ({ series, dataPointIndex, w, value }) {
            let toolTipData = [
              {
                label: trans.testing.titleC[lang],
                value: series[0][dataPointIndex].toLocaleString(),
                colour: colors[0],
              },
            ];

            const tooltipTitle = () => {
              return dateFormater(
                w.globals.initialSeries[0].data[dataPointIndex][0],
              );
            };

            return renderToString(
              ToolTipPercent(tooltipTitle(), toolTipData, true),
            );
          },
        },
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          id: 'testsTotal',
          type: 'line',
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          zoom: { enabled: true },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: trans.testing.yaxisPerc[this.props.lang],
          },
          labels: {
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            style: { ...labelStyle },
          },
        },
        stroke: stroke,
        xaxis: {
          ...lineXaxis(true),
        },
        responsive: responsiveFun().map((item) => {
          item.options.xaxis = { ...lineXaxis(true) };
          item.options.yaxis.title.text =
            trans.testing.yaxisPerc[this.props.lang];
          item.options.yaxis.labels.formatter = (value) =>
            this.props.lang === 'fr'
              ? value.toLocaleString()
              : value
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '%';
          return item;
        }),
        fill: {
          opacity: 1,
        },
      },
      ready: true,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <ReactApexChart
                ref={this.state.chartRef}
                options={this.state.options}
                series={this.state.series}
                height="400px"
                aria-hidden="true"
              />
            </>
          );
        case viewModes.table:
          return <StackedTable lang={this.props.lang} />;
        default:
      }
    };

    return (
      <div id="">
        {this.state.ready && (
          <>
            <p>{trans.testing.desc6[this.props.lang]}</p>

            <ButtonGroup
              selected={this.state.selectedViewMode}
              viewModes={viewModes}
              lang={this.props.lang}
              handleOnClick={this.onViewModeChange}
            />
            <GetRightView />
          </>
        )}
      </div>
    );
  }
}
export default PercentPositiveTotal;
